<template>
  <section class="ar-manager">
    <el-tabs v-model="activeName">
      <el-tab-pane label="用户管理" name="ar">
        <Ar v-if="isAr"/>
      </el-tab-pane>
      <el-tab-pane label="场管理列表" name="group">
        <Group v-if="!isAr"/>
      </el-tab-pane>
    </el-tabs>
  </section>
</template>

<script>
import Ar from './ar';
import Group from './group';

export default {
  name: 'ArManager',
  data() {
    return {
      activeName: 'ar'
    }
  },
  computed: {
    isAr() {
      return this.activeName === 'ar';
    }
  },
  components: {
    Ar,
    Group,
  }
}
</script>

<style scoped>
.ar-manager {
  padding: 0 30px;
  box-sizing: border-box;
  width: 100%;
}
</style>
